import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Soft loans worth 150 billion baht at @% interest for two
                    years extended by special financial institutes (SFIs) for
                    entrepreneurs. A loan of no more than 20 million baht for
                    each.
                </li>
                <li>
                    A moratorium on principal payment for members of SFIs,
                    interest cuts, delayed debt payments.
                </li>
                <li>
                    Bank of Thailand measures to help debtors affected by
                    impact, such as the easing of debt-classification criteria.
                </li>
                <li>
                    The Social Security Office’s measures to promote employment,
                    such as soft loans worth 30 billion baht starting at a 3%
                    interest rate for three years for entrepreneurs registered
                    with the SSO.
                </li>
                <li>
                    Measures to reduce interest payment burdens, such as a 1.5x
                    deduction of interest expense for SMEs that take part in
                    debt-restructuring programmes.
                </li>
                <li>
                    Measures to boost liquidity for entrepreneurs, such as
                    reducing the withholding tax from 3% to 1.5% from April to
                    September.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Thailand unveils $17 billion stimulus package to ease coronavirus impact',
            url: 'https://www.straitstimes.com/asia/se-asia/thailand-unveils-us127-billion-stimulus-package-to-ease-coronavirus-impact',
        },
        {
            title: 'Thailand plans $10 billion stimulus to support economy',
            url: 'https://www.reuters.com/article/us-thailand-economy/thailand-plans-10-billion-stimulus-to-support-economy-idUSKCN1V609T',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Thailand',
    lastUpdated: 'March 17, 2020',
    introSection: <p>Thailand has announced a $17 billion stimulus package.</p>,
    sections: [PACKAGE_SECTION],
};

const ThailandInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default ThailandInfo;
